import { createContext, FunctionComponent, ReactNode, RefObject, useContext } from 'react'

type AdditionalProps = object

type OnCloseCallbacks = {
  onBeforeDefaultClose?: () => void | Promise<boolean>
  onAfterDefaultClose?: () => void
}

export type FlyoutContainerProps = {
  color?: string
  altColor?: string
  width?: string
  closeTrackingLabel?: string
} & OnCloseCallbacks

export type FlyoutHandler = {
  open: <T extends AdditionalProps>(comp: (props: T) => Promise<ReactNode> | ReactNode, containerProps: FlyoutContainerProps, additionalProps?: T) => void
  close: () => Promise<void>
}

export type FlyoutContent<T extends AdditionalProps = AdditionalProps> = {
  Component: FunctionComponent<T>
  additionalProps?: T
  containerProps: FlyoutContainerProps
}

export type CloseGuardContextType = {
  guardRef: RefObject<(() => Promise<boolean> | boolean) | null>
}

export const GlobalFlyoutContext = createContext<FlyoutHandler>({
  open: () => {},
  close: async () => {},
})

export const CloseGuardContext = createContext<CloseGuardContextType | null>(null)

export const useFlyout = () => useContext(GlobalFlyoutContext)
